import moment from 'moment'

export default function createMomentObject(date) {
    const dateObj = new Date(date)
    return moment(dateObj)
}
